module.exports = __webpack_public_path__ + "static/media/Complete.cd14b74f.svg";